import React from 'react';
import LegalLayout from './LegalLayout';

const CGU = () => (
  <LegalLayout title="Conditions Générales d'Utilisation" slug="cgu" lastUpdated="27 octobre 2026">
    <h2>1. Objet</h2>
    <p>
      Les présentes Conditions Générales d'Utilisation (ci-après « <strong>CGU</strong> ») régissent
      l'accès et l'utilisation de la plateforme OpenSapiens (ci-après la « <strong>Plateforme</strong> »),
      éditée par OpenSapiens — propriétaire des domaines opensapiens.ch et opensapiens.io, dont le siège est situé à Genève, Suisse
      (ci-après « <strong>l'Éditeur</strong> »).
    </p>
    <p>
      La Plateforme permet à des particuliers et professionnels (les « <strong>Utilisateurs</strong> »)
      de partager leur expertise, publier du contenu, et organiser des sessions de mentorat ou de
      conseil en visioconférence. En créant un compte, l'Utilisateur accepte sans réserve les présentes CGU.
    </p>

    <h2>2. Phase Beta et gratuité</h2>
    <p>
      OpenSapiens est actuellement en <strong>phase Beta exclusive</strong>. Toutes les sessions
      proposées sur la Plateforme sont temporairement <strong>gratuites</strong>. Les paiements et la
      monétisation seront activés ultérieurement, après finalisation des aspects administratifs et de
      conformité. Les Utilisateurs en seront informés par email au préalable.
    </p>
    <p>
      Pendant cette phase, l'Éditeur se réserve le droit de modifier, suspendre ou supprimer toute
      fonctionnalité sans préavis afin d'améliorer le service.
    </p>

    <h2>3. Inscription et compte utilisateur</h2>
    <h3>3.1 Conditions d'inscription</h3>
    <p>
      L'inscription est ouverte à toute personne physique âgée de 16 ans ou plus. L'Utilisateur
      s'engage à fournir des informations exactes, à jour et complètes, et à les maintenir telles
      pendant toute la durée de son utilisation.
    </p>
    <h3>3.2 Sécurité du compte</h3>
    <p>
      L'Utilisateur est seul responsable de la confidentialité de son mot de passe et de toutes les
      activités effectuées sous son compte. Il s'engage à informer immédiatement l'Éditeur de toute
      utilisation non autorisée à l'adresse <a href="mailto:info@opensapiens.ch">info@opensapiens.ch</a>.
    </p>

    <h2>4. Utilisation de la Plateforme</h2>
    <h3>4.1 Engagements de l'Utilisateur</h3>
    <p>L'Utilisateur s'engage à :</p>
    <ul>
      <li>respecter les lois en vigueur, notamment en Suisse et dans l'Union européenne ;</li>
      <li>ne publier aucun contenu illicite, diffamatoire, injurieux, raciste, sexiste, violent, ou portant atteinte aux droits de tiers ;</li>
      <li>ne pas usurper l'identité d'un tiers ni utiliser de fausses informations ;</li>
      <li>respecter les droits de propriété intellectuelle des autres Utilisateurs et de tiers ;</li>
      <li>adopter un comportement courtois et bienveillant dans tous les échanges.</li>
    </ul>
    <h3>4.2 Contenus interdits</h3>
    <p>
      Sont notamment interdits : la publication d'informations confidentielles d'un employeur sans
      autorisation, le démarchage commercial agressif, la diffusion de contenus protégés par le droit
      d'auteur sans autorisation, et toute forme de harcèlement.
    </p>

    <h2>5. Sessions et mise en relation</h2>
    <p>
      Les sessions organisées entre Utilisateurs (mentorat, conseil, etc.) se déroulent en
      visioconférence via le service Jitsi Meet. L'Éditeur agit uniquement comme un intermédiaire
      technique et n'est pas partie au contrat de prestation entre les Utilisateurs.
    </p>
    <p>
      Chaque Utilisateur est responsable de la qualité du contenu qu'il diffuse et des engagements
      qu'il prend lors d'une session. L'Éditeur décline toute responsabilité quant aux propos tenus
      lors d'une session.
    </p>

    <h2>6. Propriété intellectuelle</h2>
    <p>
      L'Utilisateur conserve l'entière propriété intellectuelle des contenus qu'il publie. Toutefois,
      il accorde à l'Éditeur une licence non exclusive, mondiale et gratuite d'utilisation, de
      reproduction et de diffusion de ces contenus, strictement pour les besoins de fonctionnement et
      de promotion de la Plateforme, et pour la durée de publication du contenu.
    </p>
    <p>
      La marque OpenSapiens, le nom de domaine, les logos et l'interface graphique sont la propriété
      exclusive de l'Éditeur. Toute reproduction sans autorisation est interdite.
    </p>

    <h2>7. Données personnelles</h2>
    <p>
      Le traitement des données personnelles est détaillé dans la
      <a href="/legal/privacy"> Politique de confidentialité</a>. Conformément au RGPD (UE) et à la LPD
      (Loi fédérale suisse sur la protection des données), l'Utilisateur dispose d'un droit d'accès,
      de rectification, d'effacement et d'opposition exerçable depuis son compte ou par email à
      <a href="mailto:info@opensapiens.ch"> info@opensapiens.ch</a>.
    </p>

    <h2>8. Suppression de compte</h2>
    <p>
      L'Utilisateur peut supprimer son compte à tout moment depuis la page Paramètres. Cette
      suppression est <strong>définitive et irréversible</strong>. Les données strictement personnelles
      (profil, publications, abonnements) sont supprimées immédiatement. Les données relatives aux
      transactions et aux contreparties (réservations passées, avis) sont conservées sous forme
      anonymisée pour préserver l'historique légal de l'autre partie.
    </p>

    <h2>9. Responsabilité</h2>
    <p>
      L'Éditeur s'engage à fournir un service avec diligence, sans pouvoir toutefois garantir une
      disponibilité ininterrompue. L'Éditeur ne saurait être tenu responsable des dommages indirects
      résultant de l'utilisation de la Plateforme, ni des contenus publiés par les Utilisateurs.
    </p>

    <h2>10. Résiliation</h2>
    <p>
      L'Éditeur se réserve le droit de suspendre ou de supprimer le compte d'un Utilisateur qui
      enfreindrait les présentes CGU, sans préavis ni indemnité. L'Utilisateur peut résilier son
      compte à tout moment depuis la page Paramètres.
    </p>

    <h2>11. Modification des CGU</h2>
    <p>
      Les présentes CGU peuvent être modifiées à tout moment. Les Utilisateurs seront informés des
      modifications substantielles par email et/ou par notification dans l'application. La poursuite
      de l'utilisation de la Plateforme vaut acceptation des nouvelles CGU.
    </p>

    <h2>12. Droit applicable et juridiction</h2>
    <p>
      Les présentes CGU sont soumises au droit suisse. Tout litige sera porté devant les tribunaux
      compétents de Genève, sous réserve des dispositions impératives applicables aux consommateurs.
    </p>

    <h2>13. Contact</h2>
    <p>
      Pour toute question relative aux présentes CGU, contactez :
      <a href="mailto:info@opensapiens.ch"> info@opensapiens.ch</a>
    </p>
  </LegalLayout>
);

export default CGU;
